export default __webpack_public_path__ + "static/media/rick-tac-toe.eeef2002.mp4";